import {
    createContext, useContext,
} from 'react'

import {
    StepperContextType,
} from 'app/types/common.types'

import {
    LongTermLeaseType,
} from '../longTermLease.types'

export type LongTermLeaseFormContextType = StepperContextType<{
    firstStep: Partial<LongTermLeaseType>,
    secondStep: Partial<LongTermLeaseType>,
    thirdStep: Partial<LongTermLeaseType>,
}>

export const LongTermLeaseFormContext = createContext<LongTermLeaseFormContextType>(null)

const useLongTermLeaseFormContext = () => {
    return useContext<LongTermLeaseFormContextType>(LongTermLeaseFormContext)
}

export default useLongTermLeaseFormContext
